export default {
  "terms": [
    {
      "year": "2024-25",
      "michaelmas": {
        "week0": {
          "start": "2024-10-06",
          "end": "2024-10-12"
        },
        "week1": {
          "start": "2024-10-13",
          "end": "2024-10-19"
        },
        "week2": {
          "start": "2024-10-20",
          "end": "2024-10-26"
        },
        "week3": {
          "start": "2024-10-27",
          "end": "2024-11-02"
        },
        "week4": {
          "start": "2024-11-03",
          "end": "2024-11-09"
        },
        "week5": {
          "start": "2024-11-10",
          "end": "2024-11-16"
        },
        "week6": {
          "start": "2024-11-17",
          "end": "2024-11-23"
        },
        "week7": {
          "start": "2024-11-24",
          "end": "2024-11-30"
        },
        "week8": {
          "start": "2024-12-01",
          "end": "2024-12-07"
        },
        "week9": {
          "start": "2024-12-08",
          "end": "2024-12-14"
        },
        "week10": {
          "start": "2024-12-15",
          "end": "2024-12-21"
        },
        "week11": {
          "start": "2024-12-22",
          "end": "2024-12-28"
        },
        "week12": {
          "start": "2024-12-29",
          "end": "2025-01-04"
        }
      },
      "hilary": {
        "week0": {
          "start": "2025-01-12",
          "end": "2025-01-18"
        },
        "week1": {
          "start": "2025-01-19",
          "end": "2025-01-25"
        },
        "week2": {
          "start": "2025-01-26",
          "end": "2025-02-01"
        },
        "week3": {
          "start": "2025-02-02",
          "end": "2025-02-08"
        },
        "week4": {
          "start": "2025-02-09",
          "end": "2025-02-15"
        },
        "week5": {
          "start": "2025-02-16",
          "end": "2025-02-22"
        },
        "week6": {
          "start": "2025-02-23",
          "end": "2025-03-01"
        },
        "week7": {
          "start": "2025-03-02",
          "end": "2025-03-08"
        },
        "week8": {
          "start": "2025-03-09",
          "end": "2025-03-15"
        },
        "week9": {
          "start": "2025-03-16",
          "end": "2025-03-22"
        },
        "week10": {
          "start": "2025-03-23",
          "end": "2025-03-29"
        },
        "week11": {
          "start": "2025-03-30",
          "end": "2025-04-05"
        },
        "week12": {
          "start": "2025-04-06",
          "end": "2025-04-12"
        }
      },
      "trinity": {
        "week0": {
          "start": "2025-04-20",
          "end": "2025-04-26"
        },
        "week1": {
          "start": "2025-04-27",
          "end": "2025-05-03"
        },
        "week2": {
          "start": "2025-05-04",
          "end": "2025-05-10"
        },
        "week3": {
          "start": "2025-05-11",
          "end": "2025-05-17"
        },
        "week4": {
          "start": "2025-05-18",
          "end": "2025-05-24"
        },
        "week5": {
          "start": "2025-05-25",
          "end": "2025-05-31"
        },
        "week6": {
          "start": "2025-06-01",
          "end": "2025-06-07"
        },
        "week7": {
          "start": "2025-06-08",
          "end": "2025-06-14"
        },
        "week8": {
          "start": "2025-06-15",
          "end": "2025-06-21"
        },
        "week9": {
          "start": "2025-06-22",
          "end": "2025-06-28"
        },
        "week10": {
          "start": "2025-06-29",
          "end": "2025-07-05"
        },
        "week11": {
          "start": "2025-07-06",
          "end": "2025-07-12"
        },
        "week12": {
          "start": "2025-07-13",
          "end": "2025-07-19"
        }
      }
    },
    {
      "year": "2025-26",
      "michaelmas": {
        "week0": {
          "start": "2025-10-05",
          "end": "2025-10-11"
        },
        "week1": {
          "start": "2025-10-12",
          "end": "2025-10-18"
        },
        "week2": {
          "start": "2025-10-19",
          "end": "2025-10-25"
        },
        "week3": {
          "start": "2025-10-26",
          "end": "2025-11-01"
        },
        "week4": {
          "start": "2025-11-02",
          "end": "2025-11-08"
        },
        "week5": {
          "start": "2025-11-09",
          "end": "2025-11-15"
        },
        "week6": {
          "start": "2025-11-16",
          "end": "2025-11-22"
        },
        "week7": {
          "start": "2025-11-23",
          "end": "2025-11-29"
        },
        "week8": {
          "start": "2025-11-30",
          "end": "2025-12-06"
        },
        "week9": {
          "start": "2025-12-07",
          "end": "2025-12-13"
        },
        "week10": {
          "start": "2025-12-14",
          "end": "2025-12-20"
        },
        "week11": {
          "start": "2025-12-21",
          "end": "2025-12-27"
        },
        "week12": {
          "start": "2025-12-28",
          "end": "2026-01-03"
        }
      },
      "hilary": {
        "week0": {
          "start": "2026-01-11",
          "end": "2026-01-17"
        },
        "week1": {
          "start": "2026-01-18",
          "end": "2026-01-24"
        },
        "week2": {
          "start": "2026-01-25",
          "end": "2026-01-31"
        },
        "week3": {
          "start": "2026-02-01",
          "end": "2026-02-07"
        },
        "week4": {
          "start": "2026-02-08",
          "end": "2026-02-14"
        },
        "week5": {
          "start": "2026-02-15",
          "end": "2026-02-21"
        },
        "week6": {
          "start": "2026-02-22",
          "end": "2026-02-28"
        },
        "week7": {
          "start": "2026-03-01",
          "end": "2026-03-07"
        },
        "week8": {
          "start": "2026-03-08",
          "end": "2026-03-14"
        },
        "week9": {
          "start": "2026-03-15",
          "end": "2026-03-21"
        },
        "week10": {
          "start": "2026-03-22",
          "end": "2026-03-28"
        },
        "week11": {
          "start": "2026-03-29",
          "end": "2026-04-04"
        },
        "week12": {
          "start": "2026-04-05",
          "end": "2026-04-11"
        }
      },
      "trinity": {
        "week0": {
          "start": "2026-04-19",
          "end": "2026-04-25"
        },
        "week1": {
          "start": "2026-04-26",
          "end": "2026-05-02"
        },
        "week2": {
          "start": "2026-05-03",
          "end": "2026-05-09"
        },
        "week3": {
          "start": "2026-05-10",
          "end": "2026-05-16"
        },
        "week4": {
          "start": "2026-05-17",
          "end": "2026-05-23"
        },
        "week5": {
          "start": "2026-05-24",
          "end": "2026-05-30"
        },
        "week6": {
          "start": "2026-05-31",
          "end": "2026-06-06"
        },
        "week7": {
          "start": "2026-06-07",
          "end": "2026-06-13"
        },
        "week8": {
          "start": "2026-06-14",
          "end": "2026-06-20"
        },
        "week9": {
          "start": "2026-06-21",
          "end": "2026-06-27"
        },
        "week10": {
          "start": "2026-06-28",
          "end": "2026-07-04"
        },
        "week11": {
          "start": "2026-07-05",
          "end": "2026-07-11"
        },
        "week12": {
          "start": "2026-07-12",
          "end": "2026-07-18"
        }
      }
    },
    {
      "year": "2026-27",
      "michaelmas": {
        "week0": {
          "start": "2026-10-04",
          "end": "2026-10-10"
        },
        "week1": {
          "start": "2026-10-11",
          "end": "2026-10-17"
        },
        "week2": {
          "start": "2026-10-18",
          "end": "2026-10-24"
        },
        "week3": {
          "start": "2026-10-25",
          "end": "2026-10-31"
        },
        "week4": {
          "start": "2026-11-01",
          "end": "2026-11-07"
        },
        "week5": {
          "start": "2026-11-08",
          "end": "2026-11-14"
        },
        "week6": {
          "start": "2026-11-15",
          "end": "2026-11-21"
        },
        "week7": {
          "start": "2026-11-22",
          "end": "2026-11-28"
        },
        "week8": {
          "start": "2026-11-29",
          "end": "2026-12-05"
        },
        "week9": {
          "start": "2026-12-06",
          "end": "2026-12-12"
        },
        "week10": {
          "start": "2026-12-13",
          "end": "2026-12-19"
        },
        "week11": {
          "start": "2026-12-20",
          "end": "2026-12-26"
        },
        "week12": {
          "start": "2026-12-27",
          "end": "2027-01-02"
        }
      },
      "hilary": {
        "week0": {
          "start": "2027-01-10",
          "end": "2027-01-16"
        },
        "week1": {
          "start": "2027-01-17",
          "end": "2027-01-23"
        },
        "week2": {
          "start": "2027-01-24",
          "end": "2027-01-30"
        },
        "week3": {
          "start": "2027-01-31",
          "end": "2027-02-06"
        },
        "week4": {
          "start": "2027-02-07",
          "end": "2027-02-13"
        },
        "week5": {
          "start": "2027-02-14",
          "end": "2027-02-20"
        },
        "week6": {
          "start": "2027-02-21",
          "end": "2027-02-27"
        },
        "week7": {
          "start": "2027-02-28",
          "end": "2027-03-06"
        },
        "week8": {
          "start": "2027-03-07",
          "end": "2027-03-13"
        },
        "week9": {
          "start": "2027-03-14",
          "end": "2027-03-20"
        },
        "week10": {
          "start": "2027-03-21",
          "end": "2027-03-27"
        },
        "week11": {
          "start": "2027-03-28",
          "end": "2027-04-03"
        },
        "week12": {
          "start": "2027-04-04",
          "end": "2027-04-10"
        }
      },
      "trinity": {
        "week0": {
          "start": "2027-04-18",
          "end": "2027-04-24"
        },
        "week1": {
          "start": "2027-04-25",
          "end": "2027-05-01"
        },
        "week2": {
          "start": "2027-05-02",
          "end": "2027-05-08"
        },
        "week3": {
          "start": "2027-05-09",
          "end": "2027-05-15"
        },
        "week4": {
          "start": "2027-05-16",
          "end": "2027-05-22"
        },
        "week5": {
          "start": "2027-05-23",
          "end": "2027-05-29"
        },
        "week6": {
          "start": "2027-05-30",
          "end": "2027-06-05"
        },
        "week7": {
          "start": "2027-06-06",
          "end": "2027-06-12"
        },
        "week8": {
          "start": "2027-06-13",
          "end": "2027-06-19"
        },
        "week9": {
          "start": "2027-06-20",
          "end": "2027-06-26"
        },
        "week10": {
          "start": "2027-06-27",
          "end": "2027-07-03"
        },
        "week11": {
          "start": "2027-07-04",
          "end": "2027-07-10"
        },
        "week12": {
          "start": "2027-07-11",
          "end": "2027-07-17"
        }
      }
    },
    {
      "year": "2027-28",
      "michaelmas": {
        "week0": {
          "start": "2027-10-03",
          "end": "2027-10-09"
        },
        "week1": {
          "start": "2027-10-10",
          "end": "2027-10-16"
        },
        "week2": {
          "start": "2027-10-17",
          "end": "2027-10-23"
        },
        "week3": {
          "start": "2027-10-24",
          "end": "2027-10-30"
        },
        "week4": {
          "start": "2027-10-31",
          "end": "2027-11-06"
        },
        "week5": {
          "start": "2027-11-07",
          "end": "2027-11-13"
        },
        "week6": {
          "start": "2027-11-14",
          "end": "2027-11-20"
        },
        "week7": {
          "start": "2027-11-21",
          "end": "2027-11-27"
        },
        "week8": {
          "start": "2027-11-28",
          "end": "2027-12-04"
        },
        "week9": {
          "start": "2027-12-05",
          "end": "2027-12-11"
        },
        "week10": {
          "start": "2027-12-12",
          "end": "2027-12-18"
        },
        "week11": {
          "start": "2027-12-19",
          "end": "2027-12-25"
        },
        "week12": {
          "start": "2027-12-26",
          "end": "2028-01-01"
        }
      },
      "hilary": {
        "week0": {
          "start": "2028-01-09",
          "end": "2028-01-15"
        },
        "week1": {
          "start": "2028-01-16",
          "end": "2028-01-22"
        },
        "week2": {
          "start": "2028-01-23",
          "end": "2028-01-29"
        },
        "week3": {
          "start": "2028-01-30",
          "end": "2028-02-05"
        },
        "week4": {
          "start": "2028-02-06",
          "end": "2028-02-12"
        },
        "week5": {
          "start": "2028-02-13",
          "end": "2028-02-19"
        },
        "week6": {
          "start": "2028-02-20",
          "end": "2028-02-26"
        },
        "week7": {
          "start": "2028-02-27",
          "end": "2028-03-04"
        },
        "week8": {
          "start": "2028-03-05",
          "end": "2028-03-11"
        },
        "week9": {
          "start": "2028-03-12",
          "end": "2028-03-18"
        },
        "week10": {
          "start": "2028-03-19",
          "end": "2028-03-25"
        },
        "week11": {
          "start": "2028-03-26",
          "end": "2028-04-01"
        },
        "week12": {
          "start": "2028-04-02",
          "end": "2028-04-08"
        }
      },
      "trinity": {
        "week0": {
          "start": "2028-04-16",
          "end": "2028-04-22"
        },
        "week1": {
          "start": "2028-04-23",
          "end": "2028-04-29"
        },
        "week2": {
          "start": "2028-04-30",
          "end": "2028-05-06"
        },
        "week3": {
          "start": "2028-05-07",
          "end": "2028-05-13"
        },
        "week4": {
          "start": "2028-05-14",
          "end": "2028-05-20"
        },
        "week5": {
          "start": "2028-05-21",
          "end": "2028-05-27"
        },
        "week6": {
          "start": "2028-05-28",
          "end": "2028-06-03"
        },
        "week7": {
          "start": "2028-06-04",
          "end": "2028-06-10"
        },
        "week8": {
          "start": "2028-06-11",
          "end": "2028-06-17"
        },
        "week9": {
          "start": "2028-06-18",
          "end": "2028-06-24"
        },
        "week10": {
          "start": "2028-06-25",
          "end": "2028-07-01"
        },
        "week11": {
          "start": "2028-07-02",
          "end": "2028-07-08"
        },
        "week12": {
          "start": "2028-07-09",
          "end": "2028-07-15"
        }
      }
    },
    {
      "year": "2028-29",
      "michaelmas": {
        "week0": {
          "start": "2028-10-01",
          "end": "2028-10-07"
        },
        "week1": {
          "start": "2028-10-08",
          "end": "2028-10-14"
        },
        "week2": {
          "start": "2028-10-15",
          "end": "2028-10-21"
        },
        "week3": {
          "start": "2028-10-22",
          "end": "2028-10-28"
        },
        "week4": {
          "start": "2028-10-29",
          "end": "2028-11-04"
        },
        "week5": {
          "start": "2028-11-05",
          "end": "2028-11-11"
        },
        "week6": {
          "start": "2028-11-12",
          "end": "2028-11-18"
        },
        "week7": {
          "start": "2028-11-19",
          "end": "2028-11-25"
        },
        "week8": {
          "start": "2028-11-26",
          "end": "2028-12-02"
        },
        "week9": {
          "start": "2028-12-03",
          "end": "2028-12-09"
        },
        "week10": {
          "start": "2028-12-10",
          "end": "2028-12-16"
        },
        "week11": {
          "start": "2028-12-17",
          "end": "2028-12-23"
        },
        "week12": {
          "start": "2028-12-24",
          "end": "2028-12-30"
        }
      },
      "hilary": {
        "week0": {
          "start": "2029-01-07",
          "end": "2029-01-13"
        },
        "week1": {
          "start": "2029-01-14",
          "end": "2029-01-20"
        },
        "week2": {
          "start": "2029-01-21",
          "end": "2029-01-27"
        },
        "week3": {
          "start": "2029-01-28",
          "end": "2029-02-03"
        },
        "week4": {
          "start": "2029-02-04",
          "end": "2029-02-10"
        },
        "week5": {
          "start": "2029-02-11",
          "end": "2029-02-17"
        },
        "week6": {
          "start": "2029-02-18",
          "end": "2029-02-24"
        },
        "week7": {
          "start": "2029-02-25",
          "end": "2029-03-03"
        },
        "week8": {
          "start": "2029-03-04",
          "end": "2029-03-10"
        },
        "week9": {
          "start": "2029-03-11",
          "end": "2029-03-17"
        },
        "week10": {
          "start": "2029-03-18",
          "end": "2029-03-24"
        },
        "week11": {
          "start": "2029-03-25",
          "end": "2029-03-31"
        },
        "week12": {
          "start": "2029-04-01",
          "end": "2029-04-07"
        }
      },
      "trinity": {
        "week0": {
          "start": "2029-04-15",
          "end": "2029-04-21"
        },
        "week1": {
          "start": "2029-04-22",
          "end": "2029-04-28"
        },
        "week2": {
          "start": "2029-04-29",
          "end": "2029-05-05"
        },
        "week3": {
          "start": "2029-05-06",
          "end": "2029-05-12"
        },
        "week4": {
          "start": "2029-05-13",
          "end": "2029-05-19"
        },
        "week5": {
          "start": "2029-05-20",
          "end": "2029-05-26"
        },
        "week6": {
          "start": "2029-05-27",
          "end": "2029-06-02"
        },
        "week7": {
          "start": "2029-06-03",
          "end": "2029-06-09"
        },
        "week8": {
          "start": "2029-06-10",
          "end": "2029-06-16"
        },
        "week9": {
          "start": "2029-06-17",
          "end": "2029-06-23"
        },
        "week10": {
          "start": "2029-06-24",
          "end": "2029-06-30"
        },
        "week11": {
          "start": "2029-07-01",
          "end": "2029-07-07"
        },
        "week12": {
          "start": "2029-07-08",
          "end": "2029-07-14"
        }
      }
    },
    {
      "year": "2029-30",
      "michaelmas": {
        "week0": {
          "start": "2029-09-30",
          "end": "2029-10-06"
        },
        "week1": {
          "start": "2029-10-07",
          "end": "2029-10-13"
        },
        "week2": {
          "start": "2029-10-14",
          "end": "2029-10-20"
        },
        "week3": {
          "start": "2029-10-21",
          "end": "2029-10-27"
        },
        "week4": {
          "start": "2029-10-28",
          "end": "2029-11-03"
        },
        "week5": {
          "start": "2029-11-04",
          "end": "2029-11-10"
        },
        "week6": {
          "start": "2029-11-11",
          "end": "2029-11-17"
        },
        "week7": {
          "start": "2029-11-18",
          "end": "2029-11-24"
        },
        "week8": {
          "start": "2029-11-25",
          "end": "2029-12-01"
        },
        "week9": {
          "start": "2029-12-02",
          "end": "2029-12-08"
        },
        "week10": {
          "start": "2029-12-09",
          "end": "2029-12-15"
        },
        "week11": {
          "start": "2029-12-16",
          "end": "2029-12-22"
        },
        "week12": {
          "start": "2029-12-23",
          "end": "2029-12-29"
        }
      },
      "hilary": {
        "week0": {
          "start": "2030-01-06",
          "end": "2030-01-12"
        },
        "week1": {
          "start": "2030-01-13",
          "end": "2030-01-19"
        },
        "week2": {
          "start": "2030-01-20",
          "end": "2030-01-26"
        },
        "week3": {
          "start": "2030-01-27",
          "end": "2030-02-02"
        },
        "week4": {
          "start": "2030-02-03",
          "end": "2030-02-09"
        },
        "week5": {
          "start": "2030-02-10",
          "end": "2030-02-16"
        },
        "week6": {
          "start": "2030-02-17",
          "end": "2030-02-23"
        },
        "week7": {
          "start": "2030-02-24",
          "end": "2030-03-02"
        },
        "week8": {
          "start": "2030-03-03",
          "end": "2030-03-09"
        },
        "week9": {
          "start": "2030-03-10",
          "end": "2030-03-16"
        },
        "week10": {
          "start": "2030-03-17",
          "end": "2030-03-23"
        },
        "week11": {
          "start": "2030-03-24",
          "end": "2030-03-30"
        },
        "week12": {
          "start": "2030-03-31",
          "end": "2030-04-06"
        }
      },
      "trinity": {
        "week0": {
          "start": "2030-04-21",
          "end": "2030-04-27"
        },
        "week1": {
          "start": "2030-04-28",
          "end": "2030-05-04"
        },
        "week2": {
          "start": "2030-05-05",
          "end": "2030-05-11"
        },
        "week3": {
          "start": "2030-05-12",
          "end": "2030-05-18"
        },
        "week4": {
          "start": "2030-05-19",
          "end": "2030-05-25"
        },
        "week5": {
          "start": "2030-05-26",
          "end": "2030-06-01"
        },
        "week6": {
          "start": "2030-06-02",
          "end": "2030-06-08"
        },
        "week7": {
          "start": "2030-06-09",
          "end": "2030-06-15"
        },
        "week8": {
          "start": "2030-06-16",
          "end": "2030-06-22"
        },
        "week9": {
          "start": "2030-06-23",
          "end": "2030-06-29"
        },
        "week10": {
          "start": "2030-06-30",
          "end": "2030-07-06"
        },
        "week11": {
          "start": "2030-07-07",
          "end": "2030-07-13"
        },
        "week12": {
          "start": "2030-07-14",
          "end": "2030-07-20"
        }
      }
    },
    {
      "year": "2030-31",
      "michaelmas": {
        "week0": {
          "start": "2030-10-06",
          "end": "2030-10-12"
        },
        "week1": {
          "start": "2030-10-13",
          "end": "2030-10-19"
        },
        "week2": {
          "start": "2030-10-20",
          "end": "2030-10-26"
        },
        "week3": {
          "start": "2030-10-27",
          "end": "2030-11-02"
        },
        "week4": {
          "start": "2030-11-03",
          "end": "2030-11-09"
        },
        "week5": {
          "start": "2030-11-10",
          "end": "2030-11-16"
        },
        "week6": {
          "start": "2030-11-17",
          "end": "2030-11-23"
        },
        "week7": {
          "start": "2030-11-24",
          "end": "2030-11-30"
        },
        "week8": {
          "start": "2030-12-01",
          "end": "2030-12-07"
        },
        "week9": {
          "start": "2030-12-08",
          "end": "2030-12-14"
        },
        "week10": {
          "start": "2030-12-15",
          "end": "2030-12-21"
        },
        "week11": {
          "start": "2030-12-22",
          "end": "2030-12-28"
        },
        "week12": {
          "start": "2030-12-29",
          "end": "2031-01-04"
        }
      },
      "hilary": {
        "week0": {
          "start": "2031-01-12",
          "end": "2031-01-18"
        },
        "week1": {
          "start": "2031-01-19",
          "end": "2031-01-25"
        },
        "week2": {
          "start": "2031-01-26",
          "end": "2031-02-01"
        },
        "week3": {
          "start": "2031-02-02",
          "end": "2031-02-08"
        },
        "week4": {
          "start": "2031-02-09",
          "end": "2031-02-15"
        },
        "week5": {
          "start": "2031-02-16",
          "end": "2031-02-22"
        },
        "week6": {
          "start": "2031-02-23",
          "end": "2031-03-01"
        },
        "week7": {
          "start": "2031-03-02",
          "end": "2031-03-08"
        },
        "week8": {
          "start": "2031-03-09",
          "end": "2031-03-15"
        },
        "week9": {
          "start": "2031-03-16",
          "end": "2031-03-22"
        },
        "week10": {
          "start": "2031-03-23",
          "end": "2031-03-29"
        },
        "week11": {
          "start": "2031-03-30",
          "end": "2031-04-05"
        },
        "week12": {
          "start": "2031-04-06",
          "end": "2031-04-12"
        }
      },
      "trinity": {
        "week0": {
          "start": "2031-04-20",
          "end": "2031-04-26"
        },
        "week1": {
          "start": "2031-04-27",
          "end": "2031-05-03"
        },
        "week2": {
          "start": "2031-05-04",
          "end": "2031-05-10"
        },
        "week3": {
          "start": "2031-05-11",
          "end": "2031-05-17"
        },
        "week4": {
          "start": "2031-05-18",
          "end": "2031-05-24"
        },
        "week5": {
          "start": "2031-05-25",
          "end": "2031-05-31"
        },
        "week6": {
          "start": "2031-06-01",
          "end": "2031-06-07"
        },
        "week7": {
          "start": "2031-06-08",
          "end": "2031-06-14"
        },
        "week8": {
          "start": "2031-06-15",
          "end": "2031-06-21"
        },
        "week9": {
          "start": "2031-06-22",
          "end": "2031-06-28"
        },
        "week10": {
          "start": "2031-06-29",
          "end": "2031-07-05"
        },
        "week11": {
          "start": "2031-07-06",
          "end": "2031-07-12"
        },
        "week12": {
          "start": "2031-07-13",
          "end": "2031-07-19"
        }
      }
    },
    {
      "year": "2031-32",
      "michaelmas": {
        "week0": {
          "start": "2031-10-05",
          "end": "2031-10-11"
        },
        "week1": {
          "start": "2031-10-12",
          "end": "2031-10-18"
        },
        "week2": {
          "start": "2031-10-19",
          "end": "2031-10-25"
        },
        "week3": {
          "start": "2031-10-26",
          "end": "2031-11-01"
        },
        "week4": {
          "start": "2031-11-02",
          "end": "2031-11-08"
        },
        "week5": {
          "start": "2031-11-09",
          "end": "2031-11-15"
        },
        "week6": {
          "start": "2031-11-16",
          "end": "2031-11-22"
        },
        "week7": {
          "start": "2031-11-23",
          "end": "2031-11-29"
        },
        "week8": {
          "start": "2031-11-30",
          "end": "2031-12-06"
        },
        "week9": {
          "start": "2031-12-07",
          "end": "2031-12-13"
        },
        "week10": {
          "start": "2031-12-14",
          "end": "2031-12-20"
        },
        "week11": {
          "start": "2031-12-21",
          "end": "2031-12-27"
        },
        "week12": {
          "start": "2031-12-28",
          "end": "2032-01-03"
        }
      },
      "hilary": {
        "week0": {
          "start": "2032-01-11",
          "end": "2032-01-17"
        },
        "week1": {
          "start": "2032-01-18",
          "end": "2032-01-24"
        },
        "week2": {
          "start": "2032-01-25",
          "end": "2032-01-31"
        },
        "week3": {
          "start": "2032-02-01",
          "end": "2032-02-07"
        },
        "week4": {
          "start": "2032-02-08",
          "end": "2032-02-14"
        },
        "week5": {
          "start": "2032-02-15",
          "end": "2032-02-21"
        },
        "week6": {
          "start": "2032-02-22",
          "end": "2032-02-28"
        },
        "week7": {
          "start": "2032-02-29",
          "end": "2032-03-06"
        },
        "week8": {
          "start": "2032-03-07",
          "end": "2032-03-13"
        },
        "week9": {
          "start": "2032-03-14",
          "end": "2032-03-20"
        },
        "week10": {
          "start": "2032-03-21",
          "end": "2032-03-27"
        },
        "week11": {
          "start": "2032-03-28",
          "end": "2032-04-03"
        },
        "week12": {
          "start": "2032-04-04",
          "end": "2032-04-10"
        }
      },
      "trinity": {
        "week0": {
          "start": "2032-04-18",
          "end": "2032-04-24"
        },
        "week1": {
          "start": "2032-04-25",
          "end": "2032-05-01"
        },
        "week2": {
          "start": "2032-05-02",
          "end": "2032-05-08"
        },
        "week3": {
          "start": "2032-05-09",
          "end": "2032-05-15"
        },
        "week4": {
          "start": "2032-05-16",
          "end": "2032-05-22"
        },
        "week5": {
          "start": "2032-05-23",
          "end": "2032-05-29"
        },
        "week6": {
          "start": "2032-05-30",
          "end": "2032-06-05"
        },
        "week7": {
          "start": "2032-06-06",
          "end": "2032-06-12"
        },
        "week8": {
          "start": "2032-06-13",
          "end": "2032-06-19"
        },
        "week9": {
          "start": "2032-06-20",
          "end": "2032-06-26"
        },
        "week10": {
          "start": "2032-06-27",
          "end": "2032-07-03"
        },
        "week11": {
          "start": "2032-07-04",
          "end": "2032-07-10"
        },
        "week12": {
          "start": "2032-07-11",
          "end": "2032-07-17"
        }
      }
    }
  ]
};
